import { call } from 'redux-saga/effects'
import { optimisticPut } from 'utils/sagas'
import { action as apiAction } from 'api/Api'
import {
  setItem
} from '../redux/dates'

export default function * requestChangeCardCustomDate (action) {
  const { id, timestamp } = action.payload

  const optimisticAction = yield optimisticPut(setItem({
    id,
    timestamp
  }))

  try {
    yield call(apiAction, 'SetCustomDate', {
      id,
      timestamp
    })

    yield optimisticAction.commit()
  } catch (error) {
    yield optimisticAction.revert()

    throw error
  }
}
